import React, { useEffect, useRef, useState } from 'react';
import Link from '../Link';

import './index.scss';

const ScrollDiver = ({ data, gap = 1, distance = 1, startAt = 0, custom = null, onAtStart, onAtMiddle, onEnd }) => {
  const wrapper = useRef(null);
  const diverWrapper = useRef(null);
  const diverLayersRef = useRef(null);

  useEffect(() => {
    window.addEventListener('scroll', handleWatchScroll);
    diverLayersRef.current = diverWrapper.current.querySelectorAll('.layer');
    handleWatchScroll();
    return () => window.removeEventListener('scroll', handleWatchScroll);
  }, []);

  const handleWatchScroll = () => {
    checkDiverActive();


    const diverLayers = diverLayersRef.current;
    if (!diverLayers) return;

    const scrollY = window.pageYOffset;
    const offsetY = wrapper.current.offsetTop;
    const totalDistance = wrapper.current.getBoundingClientRect().height;
    const layerLength = diverLayers.length - 1;

    const scope = Math.floor((pageYOffset + offsetY) / (totalDistance + offsetY) * (layerLength + 2)) || 0;
    const min = Math.max(scope - 3, 0);
    const max = min + 6;

    // if hit bottom
    const end = Math.floor(document.body.getBoundingClientRect().height)


    if (scrollY === 0) {
      onAtStart?.();
    } else {
      if (window.scrollY + window.innerHeight >= end) {
        onEnd?.();
      } else {
        onAtMiddle?.();
      }
    }


    const layerHeight = totalDistance / (layerLength + 2);

    if (custom) {
      if (scope > custom.range[0] && scope < custom.range[1]) {
        !wrapper.current.classList.contains('-dark') && wrapper.current.classList.add('-dark');
      }
      else {
        wrapper.current.classList.contains('-dark') && wrapper.current.classList.remove('-dark');
      }
    }

    diverLayers.forEach((diverLayer) => {
      const index = Number(diverLayer.dataset.index);
      if (diverLayer && diverLayer.dataset.status !== 'empty') {
        if (index >= min && index < max) {
          diverLayer.setAttribute('style',
            `${getScale(index, scrollY, layerLength, offsetY, layerHeight)}; z-index: ${max - index};`
          )
        }
        else {
          diverLayer.setAttribute('style', `display: none`);
        }
      }
    });
  };

  const checkDiverActive = () => {
    const wrapperDom = wrapper.current
    const offsetY = wrapperDom.offsetTop;
    const offsetHeight = wrapperDom.offsetHeight;
    const toggleClass = (className, value) => wrapperDom.classList.toggle?.(className, value);

    if (window.pageYOffset <= offsetY) {
      // set 0 for offset top value, make diver work at 0px.
      toggleClass('-active', true);
      toggleClass('-finish', false);
    }
    else if (window.pageYOffset + window.innerHeight >= offsetY + offsetHeight) {
      toggleClass('-active', false);
      toggleClass('-finish', true);
    }
    else if (window.pageYOffset >= offsetY) {
      toggleClass('-active', true);
      toggleClass('-finish', false);
    }
  }

  const getScale = (index, scrollY, last, offsetY, layerHeight) => {
    const max = 3;
    const preRun = layerHeight * startAt;
    const prev = (index * layerHeight) + offsetY;

    let percent = (scrollY + preRun - prev) / (layerHeight / gap);
    if (index === 0) { percent = Math.max(percent, 1 / max) };
    if (index === last) { percent = Math.min(percent * 2, 1 / max) };


    let style = 'display: none';

    if (percent > 0 && percent < 1) {
      const transform = `transform: scale3d(${percent * max}, ${percent * max}, 1)`;

      if (percent < 0.85) style = `
        ${transform}
      `;

      else if (percent >= 0.85) style = `
        ${transform};
        opacity: ${1 - (percent - 0.85) * 6};
        filter: blur(${(percent - 0.85) * 5 * 10}px);
        pointer-events: none
      `;
    }

    return style;
  }

  const isInnerPage = (url) => {
    if (url && url.match(window.location.href)) {
      return true;
    }
    else {
      return false;
    }
  };
  const innerPage = (url) => {
    return url.replace(window.location.href, '');
  }

  return (
    <div className="scroll-diver" ref={wrapper}>
      <div className="wrapper" ref={diverWrapper}>
        {data && data.map((items, i) =>
          <div
            className="layer" key={i} style={{ transform: `scale3d(0, 0, 1)` }}
            data-status={items.content.length === 0 ? 'empty' : 'enable'}
            data-index={i}
          >
            {items.content && items.content.map((item, j) =>
              <React.Fragment key={j}>
                {(!item.link && item.image) && <div className="image" style={{ top: `${item.pos.y}%`, left: `${item.pos.x}%`, width: `${item.width}%` }}><img src={item.image} /></div>}
                {
                  (item.link && item.image) &&
                  <React.Fragment>
                    {
                      isInnerPage(item.link) ?
                        <Link className="link image" to={`${innerPage(item.link)}`} style={{ top: `${item.pos.y}%`, left: `${item.pos.x}%`, width: `${item.width}%` }}><img src={item.image} /></Link>
                        :
                        <a className="link image" href={item.link} target="_blank" style={{ top: `${item.pos.y}%`, left: `${item.pos.x}%`, width: `${item.width}%` }}><img src={item.image} /></a>
                    }
                  </React.Fragment>}
              </React.Fragment>
            )}
          </div>
        )}
      </div>
      <div className="scroller" style={{ height: `calc(${data ? (data.length + 2) * (distance * 100) : 100}vh - ${startAt * (distance * 100)}vh)` }}></div>
    </div>
  )
}

export default ScrollDiver;